module.exports = __webpack_public_path__ + "img/imgCYYQ(3).f8647b13.png";